import React, { useRef } from 'react';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { Avatar, Button, IconClose, IconShoppingCart, IconUserOutlined, Typography } from '@up-riac/bespoke-ui';
import { useContext } from 'react';
import { HeaderIconButton } from 'src/components/Header/components/HeaderIconButton';
import { AccountHeaderContext } from 'src/lib/AccountHeaderContext';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { LoginContext } from 'src/lib/LoginContext';
import { HeaderAccountPopover } from 'src/components/Header/components/HeaderAccountSection/HeaderAccountPopover';

export const HeaderAccountSection = ({ accountMenuState }: {
  accountMenuState: ReturnType<typeof useOverlayTriggerState>,
}) => {
  const { bidCart } = useContext(AccountHeaderContext);
  const { isLoggedIn } = useContext(LoginContext);
  const { firstName, lastName } = useContext(AccountHeaderContext);
  const { sendHotjarEvent } = useContext(AnalyticsContext);
  const btnRef = useRef(null);

  return (
    <>
      {isLoggedIn
        && <HeaderIconButton
          IconComponent={IconShoppingCart}
          label='Bid Cart'
          notificationCount={bidCart}
          to={'/account/cart'}
          id='header-account-section-bid-cart-button'
          onPress={() => {
            sendHotjarEvent('UX-navigation_bid_cart_button_clicked');
          }}
        />
      }
      <Button
        ref={btnRef}
        unstyled
        className='focus:rounded-full hidden lg:block relative group'
        id='header-account-section-account-menu-toggle-button'
        data-dont-close-account-popover='true'
        onPress={() => {
          sendHotjarEvent('UX-navigation_account_button_clicked');
          accountMenuState.toggle();
        }}
      >
        {accountMenuState.isOpen ? <>
          <div id='header-account-section-account-menu-close-button' className='text-text-contrast size-10 flex items-center justify-center'><IconClose className='size-6'/></div>
        </> : <>
          <Avatar className='shrink-0' id='header-account-section-account-menu-avatar'>
            {firstName ? `${firstName.trim().substring(0, 1)}${lastName ? lastName.trim().substring(0, 1) : ''}` : <IconUserOutlined/>}
          </Avatar>
          {!isLoggedIn
          && <Typography size='xs' weight='bold' className={'cursor-pointer absolute bottom-0 left-1/2 -translate-x-1/2 w-max translate-y-full text-accent transition-all'} onClick={() => btnRef.current ? btnRef.current.click() : '' }>
            Login
          </Typography>
          }
        </>}
      </Button>
      {accountMenuState.isOpen
        && <HeaderAccountPopover isOpen={accountMenuState.isOpen} onClose={accountMenuState.close}/>
      }
    </>
  );
};
